function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "pancake");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-1112.000000, -180.000000)"
}, React.createElement("g", {
  id: "pancake",
  transform: "translate(1112.000000, 180.000000)"
}, React.createElement("ellipse", {
  id: "Oval-4",
  fill: "#E8E8E8",
  cx: 129.6,
  cy: 139.2,
  rx: 129.6,
  ry: 28.8
}), React.createElement("g", {
  id: "Group-2",
  transform: "translate(19.200000, 86.400000)"
}, React.createElement("path", {
  d: "M110.4,76.8 C200.545521,76.2098999 220.8,54.8077344 220.8,33.6 C220.8,12.3922656 171.372236,0 110.4,0 C49.4277636,0 0,12.3922656 0,33.6 C0,54.8077344 20.2544792,77.3901001 110.4,76.8 Z",
  id: "Oval-2",
  fill: "#F8D8A2"
}), React.createElement("ellipse", {
  id: "Oval-2",
  fill: "#D99547",
  cx: 110.4,
  cy: 31.2,
  rx: 110.4,
  ry: 31.2
})), React.createElement("g", {
  id: "Group-2",
  transform: "translate(19.200000, 57.600000)"
}, React.createElement("path", {
  d: "M110.4,76.8 C200.545521,76.2098999 220.8,54.8077344 220.8,33.6 C220.8,12.3922656 171.372236,0 110.4,0 C49.4277636,0 0,12.3922656 0,33.6 C0,54.8077344 20.2544792,77.3901001 110.4,76.8 Z",
  id: "Oval-2",
  fill: "#F8D8A2"
}), React.createElement("ellipse", {
  id: "Oval-2",
  fill: "#D99547",
  cx: 110.4,
  cy: 31.2,
  rx: 110.4,
  ry: 31.2
})), React.createElement("g", {
  id: "Group-2",
  transform: "translate(19.200000, 28.800000)"
}, React.createElement("path", {
  d: "M110.4,76.8 C200.545521,76.2098999 220.8,54.8077344 220.8,33.6 C220.8,12.3922656 171.372236,0 110.4,0 C49.4277636,0 0,12.3922656 0,33.6 C0,54.8077344 20.2544792,77.3901001 110.4,76.8 Z",
  id: "Oval-2",
  fill: "#F8D8A2"
}), React.createElement("ellipse", {
  id: "Oval-2",
  fill: "#D99547",
  cx: 110.4,
  cy: 31.2,
  rx: 110.4,
  ry: 31.2
})), React.createElement("g", {
  id: "Group-2",
  transform: "translate(19.200000, 0.000000)"
}, React.createElement("path", {
  d: "M110.4,76.8 C200.545521,76.2098999 220.8,54.8077344 220.8,33.6 C220.8,12.3922656 171.372236,0 110.4,0 C49.4277636,0 0,12.3922656 0,33.6 C0,54.8077344 20.2544792,77.3901001 110.4,76.8 Z",
  id: "Oval-2",
  fill: "#F8D8A2"
}), React.createElement("ellipse", {
  id: "Oval-2",
  fill: "#D99547",
  cx: 110.4,
  cy: 31.2,
  rx: 110.4,
  ry: 31.2
})), React.createElement("path", {
  d: "M166.9771,108.003485 C166.9771,114.527046 161.769968,119.834441 155.28214,119.996201 L154.9771,120 C148.349683,120 142.9771,114.630228 142.9771,108.003485 L142.9771,50.3965153 L142.9733,50.0915732 C142.811493,43.6058196 137.502557,38.4 130.9771,38.4 L130.9771,38.4 L130.67206,38.4037988 C124.184232,38.5655592 118.9771,43.8729535 118.9771,50.3965153 L118.9771,50.3965153 L118.9771,108.003485 C118.9771,114.527046 113.769968,119.834441 107.28214,119.996201 L106.9771,120 C100.349683,120 94.9771,114.630228 94.9771,108.003485 L94.9771,50.3965153 C94.9771,44.9591878 91.3600553,40.3681047 86.4006233,38.8951907 L86.3993817,38.5382467 C66.1171305,35.6870821 52.8,30.8842991 52.8,25.4399998 C52.8,16.6918095 87.1845312,9.6 129.6,9.6 C172.015469,9.6 206.4,16.6918095 206.4,25.4399998 C206.4,30.44209 195.158359,34.9026449 177.601592,37.8055709 L177.600288,38.4780717 C171.620181,39.1607199 166.9771,44.2364032 166.9771,50.3965153 L166.9771,50.3965153 L166.9771,108.003485 Z",
  id: "Combined-Shape",
  fill: "#DB3A23"
}), React.createElement("g", {
  id: "Group-3",
  transform: "translate(96.000000, 0.000000)"
}, React.createElement("polygon", {
  id: "Polygon-2",
  fill: "#FADE64",
  points: "36 0 72 12.48 36 24.96 0 12.48"
}), React.createElement("polygon", {
  id: "Rectangle-4",
  fill: "#E8D272",
  points: "0 12.48 36 24.96 36 31.2 0 18.72"
}), React.createElement("polygon", {
  id: "Rectangle-4",
  fill: "#FFE882",
  transform: "translate(54.000000, 21.840000) scale(-1, 1) translate(-54.000000, -21.840000) ",
  points: "36 12.48 72 24.96 72 31.2 36 18.72"
})))));

var SvgPancake = function SvgPancake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "260px",
    height: "168px",
    viewBox: "0 0 260 168",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPancake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pancake.9de8a1d2.svg";
export { ForwardRef as ReactComponent };